import React, { useEffect } from 'react'
import { useLocation, useSearchParams, useNavigate } from 'react-router-dom'
import { useState } from 'react'
import Agree from './Agree'
import BarLoader from 'react-spinners/BarLoader'
import ShareBtn from '../ShareBtn'
import { decodeBirthDate } from '../utils/birthDateCodec'

function Layout({ setCompletionMessage }) {
  const [ac, setAc] = useState(null)
  const [tk, setTk] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [showShareBtn, setShowShareBtn] = useState(true)

  const { pathname } = useLocation()
  const pid = 'P' + pathname.toLowerCase().split('/p')[1]

  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const birthDate = decodeBirthDate(searchParams.get('d'))

  useEffect(() => {
    if (!birthDate) navigate(`/${pid}/notFound`)
  }, [birthDate, navigate, pid])

  const actualInnerWidth = document.body.clientWidth - 20
  const shareUrl = `${window.location.origin}/${pid.toLowerCase()}`

  if (!birthDate) return null

  return (
    <>
      <BarLoader
        cssOverride={{ overflow: 'hidden', position: 'fixed', zIndex: '1021' }}
        color="#19b394"
        width={actualInnerWidth}
        loading={isLoading}
      />

      <Agree
        setIsLoading={setIsLoading}
        pid={pid}
        setAc={setAc}
        setTk={setTk}
        ac={ac}
        tk={tk}
        setShowShareBtn={setShowShareBtn}
        setCompletionMessage={setCompletionMessage}
        birthDate={birthDate}
      />
      <ShareBtn showShareBtn={showShareBtn} shareUrl={shareUrl} />
    </>
  )
}

export default Layout
